var React = require('react');

function WifiOff (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1","y1":"1","x2":"23","y2":"23","key":0}),React.createElement("path",{"d":"M16.72 11.06A10.94 10.94 0 0 1 19 12.55","key":1}),React.createElement("path",{"d":"M5 12.55a10.94 10.94 0 0 1 5.17-2.39","key":2}),React.createElement("path",{"d":"M10.71 5.05A16 16 0 0 1 22.58 9","key":3}),React.createElement("path",{"d":"M1.42 9a15.91 15.91 0 0 1 4.7-2.88","key":4}),React.createElement("path",{"d":"M8.53 16.11a6 6 0 0 1 6.95 0","key":5}),React.createElement("line",{"x1":"12","y1":"20","x2":"12","y2":"20","key":6})]);
}

WifiOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-wifi-off"};

module.exports = WifiOff;

WifiOff.default = WifiOff;
